import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/door-access/control-hubs/elevator-hub.png";
import type { Product } from "../../types";
import { doorAccessControlHubs } from "../product-list-groups/doorAccessControlHubs";

export const elevatorHub: Product = {
  id: "elevatorHub",
  productTitle: "Elevator Hub",
  description: "elevatorHub.description",
  productListGroup: doorAccessControlHubs,
  techspecsPath: [SiteId.TechSpecs, "/unifi/door-access/ua-sk-elevator"],
  storePathParts: {
    category: "door-access-hub",
    productSlug: "ua-sk-elevator",
  },
  customBadges: [
    {
      value: {
        type: "translation",
        value: "commons.badge.kitIncluded",
      },
      variant: "lightGrey",
    },
  ],
  image: { src: image, width: 200, height: 160 },
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "string",
        value: '129.3 x 244.7 x 33.6 mm\n(5.1 x 9.6 x 1.3")',
      },
    },
    {
      propertyId: "outputRelays",
      value: {
        type: "translation",
        value: "elevatorHub.outputRelays",
      },
    },
    {
      propertyId: "inputTerminals",
      value: {
        type: "translation",
        value: "elevatorHub.inputTerminals",
      },
    },
    {
      propertyId: "poePorts",
      value: {
        type: "translation",
        value: "elevatorHub.poePorts",
      },
    },
    {
      propertyId: "accessPowerMethod",
      value: {
        type: "string",
        value: "PoE++",
      },
    },
    {
      propertyId: "powerRedundancy",
      value: { type: "boolean", value: false },
    },
  ],
};
